//imports
import { all } from 'redux-saga/effects';

//Views
import sourceMigrationSagas from 'Modules/importAccount/views/main/.components/sourceMigration/redux/saga';
import newMigrationSagas from 'Modules/importAccount/views/main/.components/newMigration/redux/saga';
import exceptionDetailsSagas from 'Modules/importAccount/views/main/.components/exceptionDetails/redux/saga';
//merge sagas
export default function* rootSaga() {
    yield all([
        sourceMigrationSagas(),
        newMigrationSagas(),
        exceptionDetailsSagas(),
    ]);
}